import React, { useEffect, useContext, useState } from 'react';
import { CheckBox, Box, Grid } from 'wt-ui';

import API from '../../services/API';
import FilteredContext from '../../contexts/FilteredContext';

const Navigation = () => {
  const [assetClasses, setAssetClasses] = useState([]);
  const { filters, setFilters } = useContext(FilteredContext);

  const loadContent = async () => {
    const result = await API.getAssetClasses();
    setAssetClasses(result);
  };

  useEffect(() => {
    loadContent();
  }, []);

  /*
    key = name of the group
    isChecked = was group cehcked or unchecked
  */
  const onFiltersChange = (key, isChecked) => {
    setFilters({
      ...filters,
      [key]: isChecked,
    });
  };

  return (
    <Grid columns="small">
      {assetClasses.map((assetClass) => (
        <Box key={assetClass.name} background="transparent">
          {assetClass.groups.map((g) => (
            <CheckBox
              key={`_${g.name}`}
              label={g.name}
              checked={filters[g.name] || false}
              onChange={() => onFiltersChange(g.name, !filters[g.name])}
            />
          ))}
        </Box>
      ))}
    </Grid>
  );
};

export default Navigation;
